import { Alert, Table, Tabs } from "antd"
import {useContext, useState} from "react";
import { TabPane } from "semantic-ui-react"
import { ModalVisualizarDocumentos } from "../../../../components/Generales/ModalVisualizarDocumentos";
import {TemplateContext} from "../../../../utils/template_context";

export const Educacion = ({ jurado }: any) => {

    const context = useContext(TemplateContext);
    const columnsFormal: any = [
        {
            title: "No.",
            width: 40,
            render: (datos: any, datos2: any, index: number) => {
                return (
                    <span>{index + 1}</span>
                );
            },
            fixed: context.device === "md"? "left": false,
        },
        {
            title: "Titulo",
            width: 140,
            dataIndex: "titulo",
            key: "titulo",
            render: (text: string) => (
                <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
                    {text}
                </div>
            ),
        },
        {
            title: "Nivel de educación",
            width: 140,
            dataIndex: "nivel_educacion",
            key: "nivel_educacion",
        },
        {
            title: "Institución educativa",
            width: 140,
            dataIndex: "institucion_educativa",
            key: "institucion_educativa",
            render: (text: string) => (
                <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
                    {text}
                </div>
            ),
        },
        {
            title: "Ciudad",
            width: 140,
            dataIndex: "ciudad",
            key: "ciudad",
        },
        {
            title: "Anexo",
            width: 140,
            fixed: context.device === "lg"? "right": false,
            render: (datos: any) => (
                <a className="button-azul-ghost" onClick={() => modalAnexo(datos)}>Anexo</a>
            )
        },
    ];
    const columnsNoFormal: any = [
        {
            title: "No.",
            width: 70,
            render: (datos: any, datos2: any, index: number) => {
                return (
                    <span>{index + 1}</span>
                );
            },
            fixed: context.device === "md"? "left": false,
        },
        {
            title: "Nombre",
            width: 140,
            dataIndex: "nombre_educacion",
            key: "nombre_educacion",
            render: (text: string) => (
                <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
                    {text}
                </div>
            ),
        },
        {
            title: "Proceso",
            width: 200,
            dataIndex: "nombre_proceso",
            key: "nombre_proceso",
            render: (text: string) => (
                <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
                    {text}
                </div>
            ),
        },
        {
            title: "Duración",
            width: 140,
            dataIndex: "duracion",
            key: "duracion",
        },
        {
            title: "Intitución",
            width: 200,
            dataIndex: "institucion",
            key: "institucion",
            render: (text: string) => (
                <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
                    {text}
                </div>
            ),
        },
        {
            title: "Fecha de inicio",
            width: 140,
            dataIndex: "fecha_inicio",
            key: "fecha_inicio",
        },
        {
            title: "Fecha de terminación",
            width: 170,
            dataIndex: "fecha_terminacion",
            key: "fecha_terminacion",
        },
        {
            title: "Número de horas",
            width: 140,
            dataIndex: "numero_horas",
            key: "numero_horas",
        },
        {
            title: "Ciudad",
            width: 140,
            dataIndex: "ciudad",
            key: "ciudad",
        },
        {
            fixed: context.device === "lg"? "right": false,
            title: "Anexo",
            width: 140,
            render: (datos: any) => (
                <a className="button-azul-ghost" onClick={() => modalAnexo(datos)}>Anexo</a>
            )
        },
    ];

    const [openModal, setOpenModal] = useState(false);
    const [documento, setDocumento] = useState('')
    const modalAnexo = (datos: any) => {
        setDocumento(datos.path_anexo)
        setOpenModal(true);
    }

    return (
        <>
            <Tabs defaultActiveKey="1" >
                <TabPane tab="Educación formal" key="1">
                    {jurado.educacion_formal !== null && jurado.educacion_formal.length !== 0 ?
                        (
                            <div className="row">
                                <div className="col-12">
                                    <Table
                                        dataSource={jurado.educacion_formal}
                                        columns={columnsFormal}
                                        scroll={{ x: 1500 }}
                                        pagination={false}
                                    />
                                </div>
                            </div>
                        )
                        :
                        (
                            <Alert
                                message="No se han diligenciados datos para está sección"
                                type="warning"

                            />
                        )
                    }

                </TabPane>
                <TabPane tab="Educación no formal" key="2">
                    {jurado.educacion_no_formal !== null && jurado.educacion_no_formal.length !== 0 ?
                        (
                            <div className="row">
                                <div className="col-12">
                                    <Table
                                        dataSource={jurado.educacion_no_formal}
                                        columns={columnsNoFormal}
                                        scroll={{ x: 1500 }}
                                        pagination={false}
                                    />
                                </div>
                            </div>
                        )
                        :
                        (
                            <Alert
                                message="No se han diligenciados datos para está sección"
                                type="warning"

                            />
                        )
                    }
                </TabPane>
            </Tabs>
            {openModal &&
                <ModalVisualizarDocumentos
                    visualizar={openModal}
                    setVisualizar={setOpenModal}
                    state={{ documento }}
                />
            }
        </>
    )
}
